export const retrieveTokenFromLocalStorage = () => {
    if (localStorage.token) {
        return localStorage.token;
    } else {
        return "";
    }
}